/** Angular */
import { Injectable } from '@angular/core';
import { Router, UrlTree, CanActivate } from '@angular/router';
/** Services */
import { BydAuthService } from '../services/byd-auth.service';

@Injectable({
  providedIn: 'root',
})
export class BydLoginGuard implements CanActivate {
  /**
   * Creates an instance of LoginGuard.
   *
   * @param router ngModule that provides navigation and URL manipulation capabilities
   * @param bydAuthService the authentication service
   */
  constructor(private router: Router, private bydAuthService: BydAuthService) {}

  /**
   * Deciding if a route can be activated.
   * If the user is logged in, navigation to the login page will be cancelled.
   * Else the current user will be redirected to the login page.
   *
   * @returns boolean | UrlTree
   */
  public canActivate(): boolean | UrlTree {
    if (this.bydAuthService.isLoggedIn) {
      return this.router.createUrlTree([this.router.url]);
    }
    return true;
  }
}
